<asn-accordion [singleItemOpen]="true">
    @for (item of accordionList; track item) {
        <div [attr.id]="'accordionItem-' + item.step">
            @if (showStep(item.step)) {
                <asn-accordion-item
                    (open)="setOpenStep(item.step)"
                    [id]="item.step.toString()"
                    [attr.data-step]="item.step.toString()"
                    [borderDisabled]="displayFirstStepOnly(item.step)"
                    [isOpen]="item.isOpen"
                    [disabled]="item.isDisabled"
                    [iconName]="getIcon(item)"
                >
                    <h2 slot="title">{{ item.title }}</h2>
                    <ng-container *ngComponentOutlet="item.component"></ng-container>
                </asn-accordion-item>
            }
        </div>
    }
</asn-accordion>
